import {
  CommandingRunsReply,
  PrepareCommandingRunReply,
} from "@/types/commandingRunTypes";
import { Client } from "./client";

export class CommandingRunController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  /** Builds the run and the request the desktop app relays to the engine. */
  prepare(operationId: string): Promise<PrepareCommandingRunReply> {
    return this.client.create('/api/commanding-runs/prepare', { operationId });
  }

  readAllForProcedure(procedureId: string): Promise<CommandingRunsReply> {
    return this.client.read(`/api/commanding-runs/procedure/${procedureId}`);
  }
}
